import React, { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import { Member } from '../../../states/types/common'

const MemberContentsHeader: FC = () => {
  const {
    commonPart,
  } = useSelector((state: RootState) => state)

  const { id } = useParams<{ id: string | undefined }>()

  const [memberDetail, setMemberDetail] = useState<Member>()

  useEffect(() => {
    if (!commonPart.members?.find((val) => val.id === Number(id))) return
    setMemberDetail(commonPart.members?.find((val) => val.id === Number(id)))
  }, [id, commonPart])

  return (
    <div style={{ textAlign: "center", marginTop: "1.5em", marginBottom: "1.5em" }}>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {
          memberDetail?.profile_image ? (
            <img alt="profile" src={memberDetail?.profile_image} className="profile_icon" style={{ width: "40px", height: "40px" }} />
          ) : (
            <img
              alt=""
              src={`/static/images/profile/${(Number(id) || 0) % 12}.jpeg`}
              className="profile_icon"
              style={{ width: "40px", height: "40px" }}
            />
          )
        }
        <span style={{ fontSize: "32px", fontWeight: "bold", color: "#094E8D" }}>
          {memberDetail?.name}
        </span>
      </div>
    </div>
  )
}

export default MemberContentsHeader
